import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tekrevol_dark_bg tabing_section web_tabs_sec p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">
              Our Tech Stack for Beautiful, Accessible, Fast, & Secure Websites
            </h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              Develop or rescue your outdated frontend with ultra-responsive
              interfaces. Our web development company uses mature and
              open-source technologies to build web products that are reliable
              and smooth across platforms. Complementing the quick, interactive
              web face, we build an extensible cloud-based backend that scales
              together with your growing business – an easy-to-shift,
              budget-friendly framework.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Frontend">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/html5.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>HTML</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/css3.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={83}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>CSS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/js.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={81}
                  />
                  <div className="text_tabs_web">
                    <h6>JavaScript</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/jquery.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={89}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>jQuery</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/reactjs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={81}
                    height={81}
                  />
                  <div className="text_tabs_web">
                    <h6>React.js</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/angular.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={81}
                    height={81}
                  />
                  <div className="text_tabs_web">
                    <h6>Angular</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Backend">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/backend/java.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Java</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/backend/node.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Node</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/backend/php.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>PHP</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/backend/python.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Python</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/backend/rails.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Rails</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Database">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/database/cassandria.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Cassandra</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/database/mongodb.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MongoDB</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/database/mysql.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MySQL</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/database/postgre.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Postgre</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Cloud">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/cloud/aws.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/cloud/azure.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/cloud/google_cloud.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Platforms</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/web/cloud/kubernetes.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>kubernetes</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
